import React from 'react'
import { useTranslation } from 'react-i18next'
import { ClockIcon, DollarIcon, EditIcon, RepeatIcon, ZapIcon, CheckCircleIcon } from './../../../shared-components/Icons'
import { AnimationContainer } from '../../../shared-components/AnimationContainer'
import styles from './ServicesSection.module.scss'

export const ServicesSection = () => {
  const { t } = useTranslation()

  const features = [
    {
      icon: <ClockIcon />,
      title: t('Saves Time'),
      description: t('Saves Time Description'),
      color: 'primary',
      metric: '60%',
      metricLabel: 'Time Saved'
    },
    {
      icon: <DollarIcon />,
      title: t('Saves Money'), 
      description: t('Saves Money Description'),
      color: 'secondary',
      metric: '75%',
      metricLabel: 'Cost Reduction'
    },
    {
      icon: <EditIcon />,
      title: t('Easy Editing'),
      description: t('Easy Editing Description'),
      color: 'blue',
      metric: '5min',
      metricLabel: 'Setup Time'
    },
    {
      icon: <RepeatIcon />,
      title: t('Multiple Uses'),
      description: t('Multiple Uses Description'),
      color: 'primary',
      metric: '100%',
      metricLabel: 'Reusability'
    },
    {
      icon: <ZapIcon />,
      title: t('Added Value'),
      description: t('Added Value Description'),
      color: 'secondary',
      metric: '10x',
      metricLabel: 'Performance'
    },
    {
      icon: <CheckCircleIcon />,
      title: t('Licensing'),
      description: t('Licensing Description'),
      color: 'blue',
      metric: '100%',
      metricLabel: 'Compliant'
    }
  ]

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <AnimationContainer animationStyle="animate">
          <div className={styles.header}>
            <div className={styles.headerBadge}>
              <span className={styles.badgeText}>Why Choose Us</span>
            </div>
            <h2 className={`${styles.title} title`}>
              {t('Features_Benefits')}
            </h2>
            <p className={`${styles.description} description`}>
              {t('Features_Benefits_Description')}
            </p>
          </div>
        </AnimationContainer>

        <div className={styles.featuresLayout}>
          {/* Left Column - Main Benefits */}
          <div className={styles.mainColumn}>
            {features.slice(0, 3).map((feature, index) => (
              <AnimationContainer key={index} animationStyle="animate">
                <div className={`${styles.featureRow} ${styles[feature.color]}`}>
                  <div className={styles.featureIcon}>
                    {feature.icon}
                  </div>
                  <div className={styles.featureContent}>
                    <h3 className={styles.featureTitle}>
                      {feature.title}
                    </h3>
                    <p className={styles.featureDescription}>
                      {feature.description}
                    </p>
                  </div>
                  <div className={styles.featureMetric}>
                    <span className={styles.metricValue}>{feature.metric}</span>
                    <span className={styles.metricLabel}>{feature.metricLabel}</span>
                  </div>
                </div>
              </AnimationContainer>
            ))}
          </div>

          {/* Center Divider */}
          <div className={styles.divider}>
            <div className={styles.dividerLine}></div>
            <div className={styles.dividerIcon}>
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L8.91 8.26L12 2Z" 
                      fill="currentColor"/>
              </svg>
            </div>
            <div className={styles.dividerLine}></div>
          </div>

          {/* Right Column - Additional Benefits */}
          <div className={styles.secondaryColumn}>
            {features.slice(3, 6).map((feature, index) => (
              <AnimationContainer key={index} animationStyle="animate">
                <div className={`${styles.featureRow} ${styles[feature.color]}`}>
                  <div className={styles.featureIcon}>
                    {feature.icon}
                  </div>
                  <div className={styles.featureContent}>
                    <h3 className={styles.featureTitle}>
                      {feature.title}
                    </h3>
                    <p className={styles.featureDescription}>
                      {feature.description}
                    </p>
                  </div>
                  <div className={styles.featureMetric}>
                    <span className={styles.metricValue}>{feature.metric}</span>
                    <span className={styles.metricLabel}>{feature.metricLabel}</span>
                  </div>
                </div>
              </AnimationContainer>
            ))}
          </div>
        </div>

        {/* Bottom Summary */}
        <AnimationContainer animationStyle="animate">
          <div className={styles.summary}>
            <div className={styles.summaryContent}>
              <h3 className={styles.summaryTitle}>Complete Solution</h3>
              <p className={styles.summaryText}>
                All these benefits work together to deliver exceptional value and results for your business.
              </p>
            </div>
            <div className={styles.summaryStats}>
              <div className={styles.stat}>
                <span className={styles.statNumber}>6</span>
                <span className={styles.statLabel}>Core Benefits</span>
              </div>
              <div className={styles.stat}>
                <span className={styles.statNumber}>24/7</span>
                <span className={styles.statLabel}>Availability</span>
              </div>
              <div className={styles.stat}>
                <span className={styles.statNumber}>100%</span>
                <span className={styles.statLabel}>Satisfaction</span>
              </div>
            </div>
          </div>
        </AnimationContainer>
      </div>
    </div>
  )
}